import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// Removed the static imports for AuthLayout, AppLayout, RouteViewComponent, TestLayout, and HomePage
import { authGuard } from '@auth0/auth0-vue'
import { auth0 } from '../auth'
import { useAuthStore } from '../stores/authStore'
import { watch } from 'vue'

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    alias: '',
    name: 'home',
    // CHANGED: Dynamically import the landing page
    component: () => import('../pages/home/LandingPage.vue'),
  },
  {
    path: '/leaders',
    name: 'Leaders',
    component: () => import('../pages/leaders/Leaders.vue'),
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('../pages/userCheck/UserCheck.vue'),
    beforeEnter: authGuard,
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('../pages/userCheck/Register.vue'),
  },
  {
    name: 'email',
    path: '/registerAuth',
    component: () => import('../pages/userCheck/email.vue'),
  },
  {
    path: '/test',
    // CHANGED: Dynamically import TestLayout
    component: () => import('../layouts/TestLayout.vue'),
    children: [
      {
        path: ':id?',
        name: 'TestPage',
        component: () => import('../pages/test/TestPage.vue'),
      },
    ],
  },
  {
    name: 'admin',
    path: '/home',
    // CHANGED: Dynamically import AppLayout
    component: () => import('../layouts/AppLayout.vue'),
    beforeEnter: authGuard,
    redirect: { name: 'start-challenge' },
    children: [
      // {
      //   name: 'leader-compass',
      //   path: 'leader-compass',
      //   component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      //   meta: {
      //     disabled: true
      //   }
      // },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        beforeEnter: authGuard,
        // CHANGED: Dynamically import RouteViewComponent
        component: () => import('../layouts/RouterBypass.vue'),
        children: [
          {
            name: 'checkout',
            path: 'checkout',
            component: () => import('../pages/payments/PaymentsPage.vue'),
            beforeEnter: authGuard,
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
            beforeEnter: authGuard,
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
      {
        path: '/start-challenge',
        name: 'start-challenge',
        component: () => import('../pages/test/TestLandingPage.vue'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/auth',
    // CHANGED: Dynamically import AuthLayout
    component: () => import('../layouts/AuthLayout.vue'),
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
        beforeEnter: (to: any, from: any, next: any) => {
          if (auth0.isLoading.value) {
            const unwatch = watch(auth0.isLoading, (isLoading: any) => {
              if (!isLoading) {
                unwatch()
                if (auth0.isAuthenticated.value) {
                  next({ name: 'user' })
                } else {
                  next()
                }
              }
            })
          } else if (auth0.isAuthenticated.value) {
            next({ name: 'user' })
          } else {
            next()
          }
        },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
  {
    name: 'Terms of service',
    path: '/terms-of-service',
    component: () => import('../pages/legal/Terms.vue'),
  },
  {
    name: 'Privacy policy',
    path: '/privacy-policy',
    component: () => import('../pages/legal/Privacy.vue'),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () => import('../pages/404.vue'),
    beforeEnter: async (to: any, from: any, next: any) => {
      while (auth0.isLoading.value) {
        await sleep(50)
      }
      const authStore = useAuthStore()
      if (authStore.isLoggedIn) {
        next({ name: '404' })
      } else {
        next({ name: 'login' })
      }
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to: any, from: any, savedPosition: any) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
